import { useFormatters } from '@/hooks/useFormatters';
import { GateDataRenderer } from '@features/gateCommon';
import { Trans } from '@lingui/macro';
import { Skeleton, Typography } from '@mui/material';
import { type FC } from 'react';
import { DisplayBox } from './DisplayBox';
import { formatPosition } from '@features/gateCommon/utils/formatPosition';

interface OperatingStatusProps {
  gateId: string | null;
}

export const LastPosition: FC<OperatingStatusProps> = ({ gateId }) => {
  const { formatMetricValue, formatRelativeTime } = useFormatters();

  return (
    <DisplayBox label={<Trans>Última posición</Trans>}>
      {gateId ? (
        <GateDataRenderer
          gateId={gateId}
          queryOptions={{ fetchPolicy: 'no-cache' }}
          render={({ lastPosition }) => {
            if (!lastPosition) return <Trans>Sin datos</Trans>;

            const [timestamp, value] = lastPosition;

            const valueText = formatPosition(value, formatMetricValue);

            const dateString = formatRelativeTime(timestamp);

            return (
              <>
                {valueText}{' '}
                <Typography component="span" fontWeight="normal" sx={{ fontSize: 12 }}>
                  / {dateString}
                </Typography>
              </>
            );
          }}
          fallback={() => <Skeleton>Estado dummy</Skeleton>}
        />
      ) : (
        <Trans>Dispositivo no seleccionado</Trans>
      )}
    </DisplayBox>
  );
};
